import { IPaginationInfo } from 'types/pagination'
import { ETenderType } from 'types/tender'

export enum ECommitteeEvaluationStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
}

export type ICommitteeEvaluation = {
  id: string
  tenderId: string
  tenderName: string
  tenderStatus: ECommitteeEvaluationStatus
  tenderWinnerName: string
  tenderMethod: ETenderType
  submissionStartTime: string
  submissionEndTime: string
}

export type ICommitteeEvaluations = {
  info: IPaginationInfo
  items: ICommitteeEvaluation[]
}
